import api from './api';

export const activityService = {

  getActivities: async () => {
    const response = await api.get('/activities');
    return response.data;
  },

  getActivityBySlug: async (slug) => {
    const response = await api.get(`/activities/${slug}`);
    return response.data;
  },

  createActivity: async (formData) => {
    const response = await api.post('/activities', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  updateActivity: async (id, formData) => {
    const response = await api.put(`/activities/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  deleteActivity: async (id) => {
    const response = await api.delete(`/activities/${id}`);
    return response.data;
  },
};